<div class="well row col-xs-12 assessment-overview">
  <h1>{{AssessmentResult?.assessment.name}}</h1>
  <h2 *ngIf="AssessmentResult?.assessment.creator">{{AssessmentResult?.assessment.creator}}</h2>
  <h2 *ngIf="AssessmentResult?.assessment.creatorUrl">{{AssessmentResult?.assessment.creatorUrl}}</h2>
  <div [innerHTML]="AssessmentResult?.assessment.description"></div>
</div>
<div class="well row col-xs-12 assessment-scale-result" *ngFor="let scaleResult of ScaleResults">
        <div class="row">
            <h3 class="col-xs-12 text-center" [id]="scaleResult.id" >
                <em>{{scaleResult.name}}</em>
                <small><em>Score:</em> {{scaleResult.score}}</small>
            </h3>
            <h4 class="col-xs-12 text-center"><em>Your Category:</em> {{scaleResult.range?.displayName}}</h4>
            <div class="col-xs-12 col-sm-offset-1 col-sm-10 col-md-offset-2 col-md-8">
                <app-scale-chart [scale-result]="scaleResult"></app-scale-chart> 
            </div>
            <div class="col-xs-12" *ngIf="scaleResult?.range?.clientContent" [innerHTML]="scaleResult?.range?.clientContent"></div>
            <app-scale-questions-list  class="col-xs-12" 
                *ngIf="scaleResult.questions" [Questions]="scaleResult.questions"></app-scale-questions-list>
        </div>
    </div>


// WEBPACK FOOTER //
// ./src/app/reports/report-items/scale-results-sections-list/scale-results-sections-list.component.html